export class TipoPlanTrabajo {
    idTipoPlanTrabajo: number;
    clave: string;
    descripcion: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/tipoPlanTrabajo.ts